var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.32 0C1.93413 0 0 1.93413 0 4.32V31.68C0 34.0659 1.93413 36 4.32 36H31.68C34.0659 36 36 34.0659 36 31.68V4.32C36 1.93413 34.0659 0 31.68 0H4.32ZM13.2166 21.6921C13.9176 22.6274 14.6204 23.5649 15.1891 23.5649C16.2579 23.5649 17.4395 21.8067 18.6472 20.0097C20.2922 17.562 21.9856 15.0424 23.508 16.7956C24.4653 17.8986 25.4518 20.3124 26.3209 22.4388C26.6236 23.1794 26.912 23.8851 27.18 24.4884V25.344C27.18 26.3593 26.3593 27.18 25.344 27.18H10.656C10.1691 27.18 9.70207 26.9866 9.35775 26.6422C9.01344 26.2979 8.82 25.8309 8.82 25.344V24.74C9.16788 23.96 9.52229 23.0821 9.84328 22.287C10.1593 21.5043 10.4429 20.8018 10.656 20.3519C11.2587 19.0801 12.236 20.3839 13.2166 21.6921ZM14.328 11.574C14.328 13.096 13.096 14.328 11.574 14.328C10.052 14.328 8.82 13.096 8.82 11.574C8.82 10.052 10.052 8.82 11.574 8.82C13.096 8.82 14.328 10.052 14.328 11.574Z",
    fill: "#A7F4FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.393b80a4cbb1dc02845ecb11afcc2c1f.svg";
export { ForwardRef as ReactComponent };